import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {getCategoryScore} from "@/pages/pagespeed/report/lhrUtils.ts";
import {PSReportCategories} from "@/pages/pagespeed/types.ts";

interface UptimeGradeBlockProps {
  performanceGrade: string;
  categories: PSReportCategories;
}
export const UptimeGradeBlock = ({performanceGrade, categories}: UptimeGradeBlockProps) => (
  <div className="bg-gray-100 rounded-3 p-3">
    <div className="d-flex mb-3">
      <div className="flex-grow-1">
        <strong>Uptime Grade</strong>
      </div>
      <TooltipIconRA
        className="ms-2"
        title="Your Uptime Grade is a comprehensive evaluation of your page’s performance, encompassing both its loading speed for users and its optimization for optimal performance."
      />
    </div>
    <div className="d-flex align-items-center gap-10">
      <div>
        <div className={`uptime-grade uptime-grade-${performanceGrade}`}>{performanceGrade}</div>
      </div>
      <div className="metric flex-fill d-flex align-items-center">
        <div>
          <small className="fs-7 fw-normal">Performance</small>
          <div className="value">{getCategoryScore(categories, "performance")}%</div>
        </div>
      </div>
      <div className="metric flex-fill d-flex align-items-center">
        <div>
          <small className="fs-7 fw-normal">Structure</small>
          <div className="value">{getCategoryScore(categories, "best-practices")}%</div>
        </div>
      </div>
    </div>
  </div>
);
